<p-confirmDialog key="groupaction" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="group" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="Title">
	<h4>Group Actions:</h4>
</div>

<div class="date-body">
	<div class="ActionOptionDiv">
		<label>Show:</label>
		<div class="ActionOption">
			<input
				type="radio"
				id="All"
				value="All"
				name="ActionDisplayOption"
				[(ngModel)]="ActionDisplayOption"
				(ngModelChange)="onActionDisplayOptionChange($event)"
			/>
			<label for="All">All</label>

			<input
				style="margin-left: 10px"
				type="radio"
				id="DateRange"
				value="DateRange"
				name="ActionDisplayOption"
				[(ngModel)]="ActionDisplayOption"
				(ngModelChange)="onActionDisplayOptionChange($event)"
			/>
			<label for="DateRange">Date Range</label>
		</div>
	</div>

	<div *ngIf="ActionDisplayOption == 'DateRange'" class="DateDiv">
		<label>Start Date:</label>
		<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="StartDate" (ngModelChange)="onStartDateChange($event)" name="StartDate"></p-calendar>

		<label style="margin-left: 10px">End Date:</label>
		<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="EndDate" (ngModelChange)="onEndDateChange($event)" name="EndDate"></p-calendar>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstGroupAction"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedGroupAction"
		dataKey="UID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--GroupActionTypeDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="GroupActionTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->

					<p-columnFilter field="GroupActionTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterGroupActionTypeDesc
								[ngModel]="value"
								[options]="lstGroupActionTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Description-->
				<th>
					<p-columnFilter type="text" field="Description" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--IncidentDTDesc-->
				<th>
					<!-- <p-columnFilter type="text" field="IncidentDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--StartDateDesc-->
				<th>
					<!-- <p-columnFilter field="StartDateDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterStartDateDesc [ngModel]="value" [options]="lstStartDateDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--EndDateDesc-->
				<th>
					<!-- <p-columnFilter field="EndDateDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterEndDateDesc [ngModel]="value" [options]="lstEndDateDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="GroupActionTypeDesc">Action Type<p-sortIcon field="GroupActionTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="Description">Description<p-sortIcon field="Description"></p-sortIcon></th>
				<th pSortableColumn="IncidentDT">Action Date<p-sortIcon field="IncidentDT"></p-sortIcon></th>
				<th pSortableColumn="StartDate">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th pSortableColumn="EndDate">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-GroupAction>
			<tr [pSelectableRow]="GroupAction" (dblclick)="onRowDblClick(GroupAction)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="GroupAction.IsVoid == 1 ? 'Red' : 'Black'">
					{{ GroupAction.GroupActionTypeDesc }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="GroupAction.IsVoid == 1 ? 'Red' : GroupAction.MessageFontColor"
				>
					{{ GroupAction.Description }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="GroupAction.IsVoid == 1 ? 'Red' : 'Black'">
					{{ GroupAction.IncidentDTDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="GroupAction.IsVoid == 1 ? 'Red' : 'Black'">
					{{ GroupAction.StartDateDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="GroupAction.IsVoid == 1 ? 'Red' : 'Black'">
					{{ GroupAction.EndDateDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button [disabled]="loading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAddAction()">Add Action</button>
	<button *ngIf="ShowNormal() == true" [disabled]="EnableEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onEditAction()">
		Edit Action
	</button>
	<button
		*ngIf="ShowNormal() == true"
		[disabled]="loading == true || SelectedGroupAction == undefined"
		class="btn btn-primary"
		style="margin-left: 5px"
		(click)="onDeleteAction()"
	>
		Delete Action
	</button>
	<button *ngIf="ShowPBIS() == true" [disabled]="EnableEdit() == false" class="btn btn-primary" style="margin-left: 5px" (click)="onVoidPBIS()">
		Void Transaction
	</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
